export default "__VITE_ASSET__CrWcEl7x__"